module.exports = __webpack_public_path__ + "static/images/gift-bg-b.31aca44.png";